import api from "./api";

const route = "/video_types";

const VideoTypeService = {
  getVideoTypes: () => api.get(route),
};

export default VideoTypeService;